import {createSlice} from "@reduxjs/toolkit";

const initialAddAppFlyerTokenState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  appFlyerTokenlist: [],
  usersCount: null,
  allgameslist: null, 
  newAppsFlyerToken: {},
  appFlyerForEdit: {},
  itemGame: {},
  itemTokens: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AddAppFlyerTokenSlice = createSlice({
  
  name: "gst",
  initialState: initialAddAppFlyerTokenState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    // getstaffUserById
    appFlyerTokenList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    AppFlyerTokenExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    GamesList: (state, action) => {
      const { allgameslist } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.allgameslist = allgameslist;
    },
    createAppsFlyerToken: (state, action) => {
      const { newAppsFlyerToken } = action.payload;
      state.error = null;
      console.log("newAppsFlyerToken",newAppsFlyerToken);
      state.newAppsFlyerToken = newAppsFlyerToken;
    },
    singleItemFetched: (state, action) => {
      console.log("action.payload.itemTokens",action.payload.itemTokens);
      state.actionsLoading = false;
      state.appFlyerForEdit = action.payload.appFlyerForEdit;
      state.itemGame = action.payload.itemGame;
      state.itemTokens = action.payload.itemTokens;
      state.error = null;
    },
  }
});
